export const iconFontAwesomeHandsHandHoldingMedical = (
	<i className="fa-solid fa-hand-holding-medical"></i>
);
